export const API_BASE_URL = process.env.VUE_APP_API_BASE_URL;
export const MANUAL_URL = process.env.VUE_APP_MANUAL_URL;
export const CONTACT_INFO = process.env.VUE_APP_CONTACT_INFO;
export default {
  API_BASE_URL,
  Region: process.env.AWS_REGION,
  UserPoolId: process.env.VUE_APP_COGNITO_USER_POOL_ID,
  ClientId: process.env.VUE_APP_COGNITO_CLIENT_ID,
  IdentityPoolId: process.env.VUE_APP_COGNITO_IDENTITY_POOL_ID,
  CognitoUserPoolUri: process.env.VUE_APP_COGNITO_USER_POOL_DOMAIN
};
